module.exports = __webpack_public_path__ + "static/img/yewu1.d56668ef.png";